import React from "react";

const MiniCourse = function MiniCourse(props) {
    return (
        <div>
            <div className="columns">
            <div className="column is-7">
                <strong>{props.literal}</strong>
            </div>
            <div className="column is-3">
                {props.shortLiteral}
            </div>
            <div className="column is-2">
                {props.code}
            </div>
            </div>
        </div>
    );
};

export default MiniCourse;
